export default __webpack_public_path__ + "static/media/Alerta.15b12a8c.png";